export const TrendingDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.0026 14.75L14.8156 12.9371L10.9522 9.07375L7.78556 12.2404L1.91931 6.36625L3.03556 5.25L7.78556 10L10.9522 6.83333L15.9397 11.8129L17.7526 10V14.75H13.0026Z"
        fill="#F04438"
      />
    </svg>
  );
};
